
export class DadosCadastroMaquinaModel {
    chaveResponsavel: String;
    cnpjResponsavel: String;
    cpfResponsavel: String;
    chaveMaquina: String;
    guid: String;
    fingerPrint: String;
    nomeMaquina: String;
    qtdDiasExpiracao: String;
    termoAceite: String;
    tipoInscricao: String;
    termo:String;
}


export class DadosRetornoCadMaquinaModel {
    chaveMaquina;
    code;
    mensagem;
    status;
    token;
}

export class TokenMaquinaModel {
    key;
    jwt;
}
